import axios from "axios";
import { userStore, router } from "@/BaseComponent";

const BASE_URL = process.env.VUE_APP_API_URL;
export const header = {
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
        Accept: "*/*",
        "X-AUTH-TOKEN": "",
    },
    withCredentials: false,
};

const setInterceptors = (axiosService: any) => {
    const user = userStore();
    axiosService.interceptors.request.use(
        function (config: any) {
            config.headers["X-AUTH-TOKEN"] = "Bearer " + user.token;
            return config;
        },
        function (error: any) {
            return Promise.reject(error);
        },
    );

    axiosService.interceptors.response.use(
        function (response: any) {
            if (response.data.returnCode === 11) {
                user.setToken(null);
                router.push("/login");
            } else if (response.data.returnCode === 0 && response.headers.authorization) {
                user.setToken(response.headers.authorization);
            }

            return response;
        },
        function (error: any) {
            return Promise.reject(error);
        },
    );

    return axiosService;
};

export const apiService = () => {
    const axiosService = axios.create(header);

    return setInterceptors(axiosService);
};
